import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Flex, BoxProps, Grid } from '../grid';
import { CroppedText, Heading } from '../typography';
interface Props {
  heading: any;
  subheading?: any;
  callToAction?: any;
  className?: string;
}
const EmptyState = t0 => {
  const $ = _c(20);
  let heading;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      heading,
      subheading: t1,
      callToAction: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = heading;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
  } else {
    heading = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const subheading = t1 === undefined ? "" : t1;
  const callToAction = t2 === undefined ? "" : t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      height: "100%",
      textAlign: "center"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyItems: "center",
      width: "100%"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== heading) {
    t5 = <Heading fontSize={3}>{heading}</Heading>;
    $[7] = heading;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== subheading) {
    t6 = subheading && <CroppedText sx={{
      maxWidth: "700px"
    }}>{subheading}</CroppedText>;
    $[9] = subheading;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== callToAction) {
    t7 = callToAction && <Flex flexWrap="wrap" justifyContent="center" sx={{
      maxWidth: "700px",
      width: "100%"
    }}>{callToAction}</Flex>;
    $[11] = callToAction;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <Grid gridGap={4} sx={t4}>{t5}{t6}{t7}</Grid>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== rest || $[18] !== t8) {
    t9 = <Flex alignSelf="center" justifyContent="center" alignItems="center" flexDirection="column" p={4} sx={t3} {...rest}>{t8}</Flex>;
    $[17] = rest;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default EmptyState;